import crop_list from "./crop_list";

const plot_manager = {

        // Titles
        title: String("Parcelas"),
        plotsManagerTitle: String("Detalles de la parcela, {plot_name}"),
        plotsManagerNewPlotTitle: String("Crear nueva parcela"),
        askForPlotSelectorTitle: String("Selecciona una parcela o bien crea una nueva"),
        paramsCropTitle: String("Parámetos del cultivo"),
        paramsIrrigationTitle: String("Parámetros del riego"),
        paramsSoilTitle: String("Parámetros del suelo"),
        paramsTemperatureTitle: String("Parámetros de temperatura"),

        // Nav buttons
        profileNavButton: String("Perfil"),
        paramsNavButton: String("Parámetros"),
        modulesNavButton: String("Estaciones"),

        // selectors
        askForTerrainSelectorDisabled: String("Selecciona una finca..."),

        // profile fields data
        plotName: String("Nombre de la parcela"),
        plotNameInfoPopover: String("En este campo puedes poner el nombre que quieras utilizar para referirte a esta parcela."),
        plotNamePlaceholder: String("Nombre de la Parcela..."),

        plotArea: String("Superficie de la parcela (ha)"),
        plotAreaInfoPopover: String("Superficie de la parcela en hectáreas"),

        plotCropArea: String("Superficie total del cultivo (ha)"),
        plotCropAreaInfoPopover: String("Superficie total del cultivo dentro de la parcela en hectáreas"),

        plotAssociatedTerrain: String("Finca asociada"),
        plotAssociatedTerrainInfoPopover: String("Cada parcela pertenece a una finca. Selecciona una finca del desplegable. En caso de no tener ninguno, crea uno desde el apartado de gestion de fincas."),

        plotSigpacCode: String("Código SIGPAC"),
        plotSigpacCodeInfoPopover: String("Código SIGPAC"),

        // params fields data
        paramsCropType: String("Tipo de cultivo"),
        paramsCropTypeInfoPopover: String("Tipo de cultivo"),
        paramsCropTypePlaceholder: String("cultivo..."),

        paramsCropPlantationAge: String("Edad"),
        paramsCropPlantationAgeInfoPopover: String("Edad de la plantación en años"),
        paramsCropPlantationAgePlaceholder: String("1"),

        paramsCropVariety: String("Variedad"),
        paramsCropVarietyInfoPopover: String("Variedad del cultivo"),
        paramsCropVarietyPlaceholder: String("variedad..."),

        paramsCropVarietyType: String("Tipo de variedad"),
        paramsCropVarietyTypeInfoPopover: String("En funció del comportamiento de la variedad y del periodo que abarca su ciclo fenológico se puede caracterizar como mas/menos temprana/tardía."),
        paramsCropVarietyTypePlaceholder: String("tipo..."),

        paramsCropTreeDistance: String("Distancia entre arboles (cm)"),
        paramsCropTreeDistanceInfoPopover: String("Distancia en centimetros entre los arboles"),

        paramsCropRowDistance: String("Distancia entre filas (cm)"),
        paramsCropRowDistanceInfoPopover: String("Distancia en centimetros entre filas de arboles"),

        paramsCropCrownDiameter: String("Diámetro de la corona (cm)"),
        paramsCropCrownDiameterInfoPopover: String("Diámetro en centimetros de la corona de los arboles"),

        paramsCropCupHeight: String("Altura de copa (cm)"),
        paramsCropCupHeightInfoPopover: String("Altura en centimetros hasta la copa del arbol"),

        paramsCropVisibleRootDepth: String("Profundidad raices (cm)"),
        paramsCropVisibleRootDepthInfoPopover: String("Profundidad de las raices visibles"),

        paramsCropCoveredPresence: String("Presencia cubierta"),
        paramsCropCoveredPresenceInfoPopover: String("Si el cultivo presenta presencia cubierta"),

        paramsCropCoefficient: String("Coeficiente del cultivo"),
        paramsCropCoefficientInfoPopover: String("Coeficiente del cultivo"),

        paramsCropDevelopmentCoefficient: String("Coeficiente de desarrollo del cultivo"),
        paramsCropDevelopmentCoefficientInfoPopover: String("Coeficiente de desarrollo del cultivo"),

        paramsIrrigationSystem: String("Sistema de riego"),
        paramsIrrigationSystemInfoPopover: String("Sistema de riego"),
        paramsIrrigationSystemPlaceholder: String("Sistema de riego..."),

        paramsDropperType: String("Tipo de gotero"),
        paramsDropperTypeInfoPopover: String("Tipo de gotero empleado en el riego"),
        paramsDropperTypePlaceholder: String("Tipo de gotero..."),

        paramsDropperFlow: String("Caudal gotero (L/h)"),
        paramsDropperFlowInfoPopover: String("Caudal del gotero en Litros por hora (L/h)"),

        paramsDroppersPerTree: String("Goteros por arbol"),
        paramsDroppersPerTreeInfoPopover: String("Número de goteros por cada arbol"),

        paramsDroppersDistance: String("Distancia entre goteros (cm)"),
        paramsDroppersDistanceInfoPopover: String("Distancia en centimetros entre los goteros"),

        paramsApplicationEfficiency: String("Eficiencia de aplicación"),
        paramsApplicationEfficiencyInfoPopover: String("Eficienciencia de aplicación"),


        paramsSoilUniformityCoefficient: String("Coeficiente de uniformidad"),
        paramsSoilUniformityCoefficientInfoPopover: String("Coeficiente de uniformidad"),

        paramsSoilOrganicMaterial: String("Materia Organica (%)"),
        paramsSoilOrganicMaterialInfoPopover: String("Porcentage de materia organica en suelo"),

        paramsSoilClayPercentage: String("Arcilla (%)"),
        paramsSoilClayPercentageInfoPopover: String("Porcentage de arcilla que contiene el suelo"),

        paramsSoilLimePercentage: String("Limo (%)"),
        paramsSoilLimePercentageInfoPopover: String("Porcentage de limo que contiene el suelo"),

        paramsSoilSandPercentage: String("Arena (%)"),
        paramsSoilSandPercentageInfoPopover: String("Porcentage de arena que contiene el suelo"),

        paramsSoilSoilTexture: String("Textura del suelo"),
        paramsSoilSoilTextureInfoPopover: String("Textura del suelo"),
        paramsSoilSoilTexturePlaceholder: String("Textura..."),

        paramsSoilTextureType: String("Tipo de textura"),
        paramsSoilTextureTypeInfoPopover: String("Tipo de textura del suelo"),
        paramsSoilTextureTypePlaceholder: String("Tipo..."),


        paramsTemperatureMax: String("Temperatura máxima (ºC)"),
        paramsTemperatureMaxInfoPopover: String("La temperatura máxima permitida."),

        paramsTemperatureMin: String("Temperatura mínima (ºC)"),
        paramsTemperatureMinInfoPopover: String("La temperatura mínima permitida"),

        paramsTemperatureKTCoefficient: String("Coeficiente KT"),
        paramsTemperatureKTCoefficientInfoPopover: String("Coeficiente KT"),

        paramsTemperatureExtraterrestrialSolarRadiation: String("Radiación solar extraterrestre"),
        paramsTemperatureExtraterrestrialSolarRadiationInfoPopover: String("Radiación solar extraterrestre en función de la latitud"),

        // months
        month0: String("Enero"),
        month1: String("Febrero"),
        month2: String("Marzo"),
        month3: String("Abril"),
        month4: String("Mayo"),
        month5: String("Junio"),
        month6: String("Julio"),
        month7: String("Agosto"),
        month8: String("Septiembre"),
        month9: String("Octubre"),
        month10: String("Noviembre"),
        month11: String("Diciembre"),

        // modules fields data
        plotModuleAddNew: String("Añadir nueva estación"),
        plotModuleNameHeader: String("Nombre de la estación"),
        plotModuleActionHeader: String("Acciones"),
        plotModuleTypeHeader: String("Tipo de estación"),
        plotModuleEnabledHeader: String("Estado"),
        plotModuleInstallationDateHeader: String("Fecha de instalación"),
        plotModuleActionModify: String("Modificar estación"),
        plotModulesNoModuleInList: String("Esta parcela no contiene ninguna estación."),

        // Buttons
        plotNewPlotButton: String("Crear nueva parcela"),
        plotUpdate: String("Actualizar datos de la parcela"),
        plotRestore: String("Restablecer todos los campos"),

        // texture names
        clayey: String("Arcilloso"),
        claySandy: String("Arcillo-arenosa"),
        claySilty: String("Arcillo-limosa"),
        claySiltyLoam: String("Franco arcillo-limosa"),
        clayerLoam: String("Franco-arcillosa"),
        sandyClayLoam: String("Franco arcillo-arenosa"),
        loamy: String("Franca"),
        siltyLoam: String("Franco-limosa"),
        silty: String("Limosa"),
        sandyLoam1: String("Franco-arenosa"),
        sandyLoam2: String("Franco-arenosa"),
        loamySandy: String("Areno-franca"),
        sandy: String("Arenosa"),

        // Texture types
        noTextureType: String("Tipo..."),
        fine: String("Fina"),
        average: String("Media"),
        thick: String("Gorda"),

        // irrigation systems
        grooves: String("Surcos"),
        beams: String("Bancales"),
        lying: String("Tendido"),
        sprinkling: String("Aspersión"),
        located: String("Localizado"),

        // irrigation types
        dropper: String("Gotero"),
        microtube: String("Microtubo"),
        integrated: String("Integrado"),
        selfCompensated: String("Autocompensado"),

        // crop type varieties
        cropVariety_early: String("Temprana"),
        cropVariety_extraEarly: String("Extra-Temprana"),
        cropVariety_normal: String("Normal"),
        cropVariety_late: String("Tardía"),
        cropVariety_extraLate: String("Extra-Tardía"),

        // errors
        plotParamsNoExtraterrestrialSolarRadiation: String("Se requiere una finca asociada a la parcela para determinar la radiación solar extraterrestre."),
        errorFieldRequired: String("Este campo es obligatorio"),
        errorInvalidLength: String("Este campo require un mínimo de {length} caracteres"),
        errorNameAlreadyExists: String("Este nombre de parcela ya existe"),
        errorNegativeNumber: String("Este campo no permite números negativos"),
        minTemperatureError: String("La temperatura mínima no puede ser inferior a {temperature}ºC"),
        maxTemperatureError: String("La temperatura máxima no puede ser superior a {temperature}ºC"),
        errorsModalTitle: String("Errores en la parcela"),
        errorsModalBodyTitle: String("No se ha podido crear/actualizar la parcela debido a los siguiente errores:"),
        errorsModalCloseButton: String("Cerrar"),
        errorModalTemperatureParams: String("Hay algún error con los parámetros de temperatura."),
        errorModalCropParams: String("Hay algún error con los parámetros del cultivo."),
        errorModalIrrigationParams: String("Hay algún error con los parámetros de riego."),
        errorModalSoilParams: String("Hay algún error con los parámetros de suelo."),
        errorModalProfile: String("Hay algún error en los campos del apartado: Perfil."),

};
plot_manager.crop_list = crop_list;

export default plot_manager;